import { render, staticRenderFns } from "./loginAdmin.vue?vue&type=template&id=2a120082&scoped=true"
import script from "./loginAdmin.vue?vue&type=script&lang=js"
export * from "./loginAdmin.vue?vue&type=script&lang=js"
import style0 from "./loginAdmin.vue?vue&type=style&index=0&id=2a120082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a120082",
  null
  
)

export default component.exports